import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ConfigCollection } from '@atlaskit/config-common-libs';
export var ConfigClient = /*#__PURE__*/function () {
  function ConfigClient() {
    _classCallCheck(this, ConfigClient);
  }
  _createClass(ConfigClient, null, [{
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        var _options$fetch;
        var fetch, response, valuesPayload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
              _context.next = 3;
              return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                method: 'POST',
                body: JSON.stringify(options.context),
                headers: {
                  'content-type': 'application/json',
                  'x-api-key': options.ffsApiKey
                }
              });
            case 3:
              response = _context.sent;
              if (response.ok) {
                _context.next = 12;
                break;
              }
              _context.t0 = Error;
              _context.t1 = "Unexpected response ".concat(response.status, ": ");
              _context.next = 9;
              return response.text();
            case 9:
              _context.t2 = _context.sent;
              _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
              throw new _context.t0(_context.t3);
            case 12:
              _context.next = 14;
              return response.text();
            case 14:
              valuesPayload = _context.sent;
              return _context.abrupt("return", ConfigCollection.fromValues(valuesPayload));
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }]);
  return ConfigClient;
}();